export default __webpack_public_path__ + "media/images/not-found-2550x1700-f608dca83b46e6b5a8706182bf263eda.jpg";